import React from 'react';
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';

export default function ViewLicenseModal({ licenseData, handleViewLicenseModal, viewLicenseModal }) {
    return (
        <Modal isOpen={viewLicenseModal} toggle={handleViewLicenseModal} backdrop={'static'}>
            <ModalHeader className="bg-primary py-2 px-2">
                <div className="text-white fw-light">
                    License Details
                </div>
                <div onClick={handleViewLicenseModal} className='text-white cursor-pointer fs-5' style={{ position: 'absolute', right: '1rem', top: '.5rem' }}>
                    <i class="ri-close-line"></i>
                </div>
            </ModalHeader>
            <ModalBody className='pb-0'>
                {licenseData ? (
                    <Row className="gy-2">
                        <Col lg={6}>
                            <div>
                                <h6 className="text-muted">Product Name</h6>
                                <p className="fw-semibold">{licenseData.productName || 'N/A'}</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <h6 className="text-muted">Type</h6>
                                <p className="fw-semibold">{licenseData.type || 'N/A'}</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <h6 className="text-muted">Status</h6>
                                <p className={`fw-semibold ${licenseData.status === 'ACTIVE' ? 'text-success' : 'text-danger'}`}>
                                    {licenseData.status || 'N/A'}
                                </p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <h6 className="text-muted">Overview</h6>
                                <p className="fw-semibold">{licenseData.overview || 'N/A'}</p>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div>
                                <h6 className="text-muted">Entry By</h6>
                                <p className="fw-semibold">{licenseData.entryBy || 'N/A'}</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <h6 className="text-muted">Entry Date</h6>
                                <p className="fw-semibold">{licenseData.entryDate || 'N/A'}</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <h6 className="text-muted">Start Date</h6>
                                <p className="fw-semibold">{licenseData.startDate || 'N/A'}</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <h6 className="text-muted">Due Date</h6>
                                <p className="fw-semibold">{licenseData.dueDate || 'N/A'}</p>
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <div className="text-center text-muted">No license data available.</div>
                )}
            </ModalBody>
        </Modal>
    );
}